import { ovl } from "../../../../../../../_ovlclient/src"
import type { SYSFormState } from "../../../../../../../_ovlclient/src/library/forms/formapi"
import {
  FieldSetState,
  FieldVal,
} from "../../../../../../../_ovlclient/src/library/forms/fieldapi"

export const SetSettingsForm = async (formState: SYSFormState) => {
  let convertedValue = FieldVal(formState.fields["U_PrtOfferingCadAttr"])
  FieldSetState(
    formState.fields["PrtOfferingCadUserField"],
    convertedValue === "Benutzerdefiniert",
    { animate: "fade", focusWhenVisible: true }
  )
}

export const GetCadAttribute = (): string => {
  let userState = ovl.getState().app.global.GEN
  let cadAttr = userState.user.offeringCadAttr
  if (userState.user.offeringCadUserField) {
    cadAttr = `User-${userState.user.offeringCadUserField}`
  }
  return cadAttr
}
